import React, {useEffect, useState, useRef} from "react";
import gsap, {TimelineMax, TweenMax} from 'gsap';
import ScrollMagic from "scrollmagic";
import {ScrollMagicPluginGsap} from "scrollmagic-plugin-gsap";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

export default function MastheadBackground({headText}) {
    const element = useRef(null);
    const [ready, setReady] = useState(false)

    useEffect(() => {
        const paths = document.querySelectorAll('.masthead--bg--svg path');

        Object.values(paths).map((path, index) => {
            gsap.to(path, .3, {
                opacity: 1,
                y: 0,
                x: 0,
                delay: .05 * index,
                onComplete: () => {
                    if (index === paths.length - 1) {
                        setReady(true);
                    }
                }
            })
        });
    }, []);

    useEffect(() => {
        const groups = element.current.querySelectorAll('[data-scroll-animation]');

        if (ready) {
            const controller = new ScrollMagic.Controller({
                refreshIntervals: 0
            });

            Object.values(groups).map(group => {
                const y = parseFloat(group.getAttribute('data-y'));
                const x = parseFloat(group.getAttribute('data-x'));

                new ScrollMagic.Scene({
                    triggerHook: 'onLeave',
                    triggerElement: element.current.closest('section'),
                    duration: '100%',
                    reverse: true
                })
                    .setTween(
                        new TimelineMax().to(group, .3, {
                            x: x, y: y, transformOrigin: 'center',
                        }, 'start'))
                    .addTo(controller);
            });
        }
    }, [ready]);

    const svg = `<svg class="masthead--bg--svg" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 927.4 388.3" style="enable-background:new 0 0 927.4 388.3;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#E13354;}
	.st1{fill:#EF8067;}
	.st2{fill:#98234D;}
	.st3{fill:#A1FCFE;}
	.st4{fill:#E88831;}
	.st5{fill:#092DF0;}
</style>
<g>

    <!-- left 1 -->
	<g>
		<path  data-scroll-animation data-y="-30" data-x="-40" class="st5" d="M149.3,62.4c-0.2,0-0.4-0.1-0.6-0.2l-39.9-39.9c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l39.9,39.9
			c0.3,0.3,0.3,0.8,0,1.1C149.7,62.4,149.5,62.4,149.3,62.4z"/>
		<path  data-scroll-animation data-y="-10" data-x="-10" class="st0" d="M123.7,48.4c-0.2,0-0.4-0.1-0.6-0.2L88.3,15c-0.2-0.2-0.3-0.5-0.2-0.8c0.1-0.3,0.3-0.5,0.6-0.6L134.8,0
			c0.3-0.1,0.6,0,0.8,0.2c0.2,0.2,0.3,0.5,0.2,0.8l-11.3,46.8c-0.1,0.3-0.3,0.5-0.6,0.6C123.9,48.4,123.8,48.4,123.7,48.4z
			 M90.4,14.8l32.9,31.3L133.9,2L90.4,14.8z"/>
	</g>
	
	<!-- left 2 -->
	<g>
		<path  data-scroll-animation data-y="-500" data-x="-40" class="st0" d="M241.9,164.1c-0.2,0-0.4-0.1-0.6-0.2l-55.8-55.1c-0.2-0.2-0.3-0.5-0.2-0.8c0.1-0.3,0.3-0.5,0.6-0.6l75.6-20.7
			c0.3-0.1,0.6,0,0.8,0.2c0.2,0.2,0.3,0.5,0.2,0.8l-19.8,75.8c-0.1,0.3-0.3,0.5-0.6,0.6C242,164.1,242,164.1,241.9,164.1z
			 M187.7,108.6l53.8,53.1l19.1-73.1L187.7,108.6z"/>
		<path  data-scroll-animation data-y="-450" data-x="-10" class="st1" d="M241.1,170c-0.2,0-0.4-0.1-0.6-0.2l-55.8-55.1c-0.2-0.2-0.3-0.5-0.2-0.8c0.1-0.3,0.3-0.5,0.6-0.6l75.6-20.7
			c0.3-0.1,0.6,0,0.8,0.2c0.2,0.2,0.3,0.5,0.2,0.8l-19.8,75.8c-0.1,0.3-0.3,0.5-0.6,0.6C241.2,170,241.1,170,241.1,170z
			 M186.8,114.5l53.8,53.1l19.1-73.1L186.8,114.5z"/>
		<path  data-scroll-animation data-y="150" data-x="20" class="st0" d="M324.6,185.6c-0.2,0-0.4-0.1-0.6-0.2l-53.8-53.8c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l53.8,53.8
			c0.3,0.3,0.3,0.8,0,1.1C325,185.5,324.8,185.6,324.6,185.6z"/>
		<path  data-scroll-animation data-y="-300" data-x="-20" class="st0" d="M314.9,179.3c-0.2,0-0.4-0.1-0.6-0.2l-59.9-59.9c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l59.9,59.9
			c0.3,0.3,0.3,0.8,0,1.1C315.3,179.2,315.1,179.3,314.9,179.3z"/>
		<path  data-scroll-animation data-y="-250" data-x="-90" class="st0" d="M236.6,166.5c-0.2,0-0.4-0.1-0.6-0.2l-62.2-62.2c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l62.2,62.2
			c0.3,0.3,0.3,0.8,0,1.1C237.1,166.5,236.8,166.5,236.6,166.5z"/>
	</g>
	
	<!-- left 3 -->
	<g>
	    <path  data-scroll-animation data-y="140" data-x="-40" class="st0" d="M149.3,172c-0.2,0-0.4-0.1-0.6-0.2l-25.9-24.7c-0.2-0.2-0.3-0.5-0.2-0.8c0.1-0.3,0.3-0.5,0.6-0.6l34.3-10.1
			c0.3-0.1,0.6,0,0.8,0.2c0.2,0.2,0.3,0.5,0.2,0.8l-8.4,34.8c-0.1,0.3-0.3,0.5-0.6,0.6C149.5,172,149.4,172,149.3,172z M124.9,146.9
			l23.9,22.8l7.8-32.1L124.9,146.9z"/>
    </g>
	
	<!-- Left 4 -->
	<g>
		<path  data-scroll-animation data-y="140" data-x="-30" class="st0" d="M152.7,351.9c-0.2,0-0.4-0.1-0.5-0.2l-111.2-102c-0.2-0.2-0.3-0.5-0.2-0.8c0.1-0.3,0.3-0.5,0.5-0.6l144-45.3
			c0.3-0.1,0.6,0,0.8,0.2c0.2,0.2,0.3,0.5,0.2,0.8l-32.7,147.3c-0.1,0.3-0.3,0.5-0.5,0.6C152.9,351.9,152.8,351.9,152.7,351.9z
			 M43,249.5l109.2,100.1L184.4,205L43,249.5z"/>
		<path  data-scroll-animation data-y="220" data-x="-120" class="st0" d="M148.4,345.1c-0.2,0-0.4-0.1-0.5-0.2l-111.2-102c-0.2-0.2-0.3-0.5-0.2-0.8c0.1-0.3,0.3-0.5,0.5-0.6l144-45.3
			c0.3-0.1,0.6,0,0.8,0.2c0.2,0.2,0.3,0.5,0.2,0.8l-32.7,147.3c-0.1,0.3-0.3,0.5-0.5,0.6C148.6,345.1,148.5,345.1,148.4,345.1z
			 M38.7,242.7l109.2,100.1l32.1-144.6L38.7,242.7z"/>
		<path  data-scroll-animation data-y="340" data-x="-40" class="st0" d="M205.5,323.2c-0.2,0-0.4-0.1-0.6-0.2l-59.2-59.2c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l59.2,59.2
			c0.3,0.3,0.3,0.8,0,1.1C205.9,323.1,205.7,323.2,205.5,323.2z"/>
		<path  data-scroll-animation data-y="325" data-x="-90" class="st5" d="M145.3,343.9c-0.2,0-0.4-0.1-0.5-0.2l-111.2-102c-0.2-0.2-0.3-0.5-0.2-0.8c0.1-0.3,0.3-0.5,0.5-0.6l144-45.3
			c0.3-0.1,0.6,0,0.8,0.2c0.2,0.2,0.3,0.5,0.2,0.8L146,343.3c-0.1,0.3-0.3,0.5-0.5,0.6C145.4,343.9,145.3,343.9,145.3,343.9z
			 M35.6,241.5l109.2,100.1L176.9,197L35.6,241.5z"/>
		<path  data-scroll-animation data-y="120" data-x="-70" class="st5" d="M202.1,323.2c-0.2,0-0.4-0.1-0.6-0.2l-59.2-59.2c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l59.2,59.2
			c0.3,0.3,0.3,0.8,0,1.1C202.5,323.1,202.3,323.2,202.1,323.2z"/>
	</g>
	
	<!-- Right 1 -->
	<g>
		<path  data-scroll-animation data-y="-150" data-x="700" class="st2" d="M850.2,162.1c-0.2,0-0.4-0.1-0.6-0.2l-83.5-85.4c-0.2-0.2-0.3-0.5-0.2-0.8c0.1-0.3,0.3-0.5,0.6-0.6
			l115.7-29.6c0.3-0.1,0.6,0,0.8,0.2c0.2,0.2,0.3,0.5,0.2,0.8l-32.2,115c-0.1,0.3-0.3,0.5-0.6,0.6
			C850.3,162.1,850.2,162.1,850.2,162.1z M768.2,76.3l81.5,83.4l31.5-112.3L768.2,76.3z"/>
		<path  data-scroll-animation data-y="-180" data-x="550" class="st3" d="M836.3,170.4c-0.2,0-0.4-0.1-0.6-0.2l-83.5-85.4c-0.2-0.2-0.3-0.5-0.2-0.8c0.1-0.3,0.3-0.5,0.6-0.6
			l115.7-29.6c0.3-0.1,0.6,0,0.8,0.2c0.2,0.2,0.3,0.5,0.2,0.8l-32.2,115c-0.1,0.3-0.3,0.5-0.6,0.6
			C836.4,170.4,836.3,170.4,836.3,170.4z M754.3,84.6l81.5,83.4l31.5-112.3L754.3,84.6z"/>
		<path  data-scroll-animation data-y="-50" data-x="450" class="st4" d="M911.4,201.3c-0.2,0-0.4-0.1-0.6-0.2l-88.3-88.3c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0l88.3,88.3
			c0.3,0.3,0.3,0.8,0,1.1C911.9,201.2,911.6,201.3,911.4,201.3z"/>
		<path  data-scroll-animation data-y="100" data-x="480" class="st2" d="M926.6,216.4c-0.2,0-0.4-0.1-0.6-0.2L822.5,112.7c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0L927.1,215
			c0.3,0.3,0.3,0.8,0,1.1C927,216.3,926.8,216.4,926.6,216.4z"/>
		<path  data-scroll-animation data-y="-130" data-x="620" class="st5" d="M821.1,170.2c-0.2,0-0.4-0.1-0.6-0.2L700.2,49.7c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l120.3,120.3
			c0.3,0.3,0.3,0.8,0,1.1C821.5,170.2,821.3,170.2,821.1,170.2z"/>
	</g>
	
	<!-- Right 2 -->	
    <g>
        <path  data-scroll-animation data-y="130" data-x="590" class="st0" d="M694.5,193.4c-0.2,0-0.4-0.1-0.5-0.2l-32.9-30.8c-0.2-0.2-0.3-0.5-0.2-0.8c0.1-0.3,0.3-0.5,0.5-0.6l43.1-13.1
			c0.3-0.1,0.6,0,0.8,0.2c0.2,0.2,0.3,0.5,0.2,0.8l-10.2,43.9c-0.1,0.3-0.3,0.5-0.5,0.6C694.7,193.4,694.6,193.4,694.5,193.4z
			 M663.2,162.1L694,191l9.6-41.2L663.2,162.1z"/>
		<path  data-scroll-animation data-y="200" data-x="540" class="st4" d="M773.9,257.8c-0.2,0-0.4-0.1-0.6-0.2l-88.4-88.4c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l88.4,88.4
			c0.3,0.3,0.3,0.8,0,1.1C774.3,257.7,774.1,257.8,773.9,257.8z"/>
		<path  data-scroll-animation data-y="-120" data-x="400" class="st0" d="M782.6,266.6c-0.2,0-0.4-0.1-0.6-0.2l-97.1-97.1c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l97.1,97.1
			c0.3,0.3,0.3,0.8,0,1.1C783,266.5,782.8,266.6,782.6,266.6z"/>
	</g>
	
	<!-- Right 3 -->
	<g>
		<path  data-scroll-animation data-y="150" data-x="500" class="st2" d="M815.9,340.4c-0.2,0-0.4-0.1-0.5-0.2l-61-55.9c-0.2-0.2-0.3-0.5-0.2-0.8c0.1-0.3,0.3-0.5,0.5-0.6l78.9-24.9
			c0.3-0.1,0.6,0,0.8,0.2c0.2,0.2,0.3,0.5,0.2,0.8l-17.9,80.8c-0.1,0.3-0.3,0.5-0.5,0.6C816.1,340.4,816,340.4,815.9,340.4z
			 M756.5,284.1l59,54l17.3-78L756.5,284.1z"/>
		<path  data-scroll-animation data-y="-300" data-x="600" class="st3" d="M810.6,346.2c-0.2,0-0.4-0.1-0.5-0.2l-61-55.9c-0.2-0.2-0.3-0.5-0.2-0.8c0.1-0.3,0.3-0.5,0.5-0.6l78.9-24.9
			c0.3-0.1,0.6,0,0.8,0.2c0.2,0.2,0.3,0.5,0.2,0.8l-17.9,80.8c-0.1,0.3-0.3,0.5-0.5,0.6C810.8,346.2,810.7,346.2,810.6,346.2z
			 M751.2,289.9l59,54l17.3-78L751.2,289.9z"/>
		<path  data-scroll-animation data-y="-200" data-x="540" class="st2" d="M896.7,388.3c-0.2,0-0.4-0.1-0.6-0.2l-83.8-83.8c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0l83.8,83.8
			c0.3,0.3,0.3,0.8,0,1.1C897.1,388.2,896.9,388.3,896.7,388.3z"/>
		<path  data-scroll-animation data-y="-150" data-x="720" class="st2" d="M859.3,340.1c-0.2,0-0.4-0.1-0.6-0.2l-46.4-46.4c-0.3-0.3-0.3-0.8,0-1.1s0.8-0.3,1.1,0l46.4,46.4
			c0.3,0.3,0.3,0.8,0,1.1C859.7,340,859.5,340.1,859.3,340.1z"/>
	</g>
	
    <!-- Right 4 -->
	<g>		
		<path  data-scroll-animation data-y="-30" data-x="460" class="st2" d="M885.3,290.2c-0.2,0-0.4-0.1-0.5-0.2l-43.5-36.1c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.3,0.2-0.5,0.5-0.6l53-19.6
			c0.3-0.1,0.6,0,0.8,0.1c0.2,0.2,0.3,0.5,0.3,0.8l-9.6,55.7c0,0.3-0.2,0.5-0.5,0.6C885.5,290.2,885.4,290.2,885.3,290.2z
			 M843.5,253.5l41.3,34.4l9.1-53L843.5,253.5z"/>
         <path  data-scroll-animation data-y="-150" data-x="660" class="st5" d="M883.7,288.6c-0.2,0-0.4-0.1-0.5-0.2l-43.5-36.1c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.3,0.2-0.5,0.5-0.6l53-19.6
			c0.3-0.1,0.6,0,0.8,0.1c0.2,0.2,0.3,0.5,0.3,0.8l-9.6,55.7c0,0.3-0.2,0.5-0.5,0.6C883.9,288.5,883.8,288.6,883.7,288.6z
			 M841.9,251.9l41.3,34.4l9.1-53L841.9,251.9z"/>
	</g>
	
	<g>
		<path  data-scroll-animation data-y="120" data-x="-300" class="st5" d="M667.4,216.8c-0.2,0-0.4-0.1-0.6-0.2l-39.9-39.9c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l39.9,39.9
			c0.3,0.3,0.3,0.8,0,1.1C667.9,216.7,667.6,216.8,667.4,216.8z"/>
		<path  data-scroll-animation data-y="-50" data-x="" class="st0" d="M63,297.2c-0.2,0-0.4-0.1-0.6-0.2L0.2,234.9c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l62.1,62.1
			c0.3,0.3,0.3,0.8,0,1.1C63.4,297.2,63.2,297.2,63,297.2z"/>
		<path  data-scroll-animation data-y="200" data-x="430" class="st5" d="M695.2,231c-0.2,0-0.4-0.1-0.6-0.2L578.9,115.1c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l115.7,115.7
			c0.3,0.3,0.3,0.8,0,1.1C695.6,231,695.4,231,695.2,231z"/>
		<path  data-scroll-animation data-y="-150" data-x="700" class="st5" d="M739.5,384.5c-0.2,0-0.4-0.1-0.6-0.2L632.1,277.4c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l106.9,106.9
			c0.3,0.3,0.3,0.8,0,1.1C740,384.4,739.8,384.5,739.5,384.5z"/>
	</g>
</g>
</svg>`

    return (
        <div ref={element} dangerouslySetInnerHTML={{__html: svg}} className={'MastheadBG'}/>
    )
}
